var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.646 8.5791C35.8067 8.5791 39.1797 11.952 39.1797 16.1128V34.8452C39.1797 36.708 37.2228 37.9223 35.5536 37.0954L29.4715 34.0821C28.4319 33.567 27.2873 33.299 26.127 33.299H12.6205C8.4598 33.299 5.08686 29.926 5.08686 25.7653V16.1128C5.08686 11.9521 8.4598 8.5791 12.6205 8.5791H31.646Z",
    fill: "url(#paint0_linear_1455_20597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0069 15.6755C26.4102 14.0789 23.8125 14.0789 22.2158 15.6755C21.1253 16.7661 20.7464 18.3733 21.2187 19.8314L16.6071 24.443C16.5373 24.5128 16.498 24.6073 16.498 24.7062V26.8121C16.498 27.0179 16.6645 27.1844 16.8703 27.1844H18.9762C19.0751 27.1844 19.1696 27.1451 19.2394 27.0753L19.7658 26.5485C19.8461 26.4682 19.8854 26.3555 19.8723 26.2424L19.8069 25.6768L20.5906 25.603C20.7688 25.5862 20.9095 25.4456 20.9262 25.2674L21 24.4836L21.5657 24.5494C21.6707 24.5636 21.7765 24.5283 21.8561 24.4578C21.9354 24.387 21.9808 24.2859 21.9808 24.1797V23.4866H22.6613C22.7602 23.4866 22.8547 23.4474 22.9245 23.3775L23.8792 22.4355C25.3369 22.9081 26.9163 22.5579 28.0069 21.4665C29.6035 19.8699 29.6035 17.2721 28.0069 15.6755ZM26.9538 18.3078C26.5182 18.7433 25.8101 18.7433 25.3746 18.3078C24.9391 17.8723 24.9391 17.1642 25.3746 16.7286C25.8101 16.2931 26.5182 16.2931 26.9538 16.7286C27.3893 17.1642 27.3892 17.8723 26.9538 18.3078Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_20597",
    x1: 7.58245,
    y1: 10.8481,
    x2: 38.4405,
    y2: 37.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BFFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#417CED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon12);
export default __webpack_public_path__ + "static/media/message_card_icon12.2b4ce7d5741c75b40f7b5eb0bc8d579f.svg";
export { ForwardRef as ReactComponent };